export const onClientEntry = () => {
  // gatsby-background-image support for older Safari and IE:
  // https://www.gatsbyjs.com/plugins/gatsby-background-image/#important
  if (!(`IntersectionObserver` in window)) {
    import(`intersection-observer`)
  }
}